import Layout from "@/components/Layout";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle, AlertTriangle } from "lucide-react";

export default function ViktigInfo() {
  return (
    <Layout>
      <section className="bg-[#3D2314] py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4 font-display">Viktig informasjon før innlevering</h1>
          <p className="text-white/80 max-w-2xl mx-auto">Litt forberedelse gjør at vi kan hjelpe deg raskere og mer nøyaktig.</p>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-[#FFF8F0]">
        <div className="max-w-3xl mx-auto px-4 space-y-8">
          <div>
            <h2 className="text-2xl font-bold text-[#3D2314] mb-4 font-display">Før du leverer inn</h2>
            <div className="space-y-3">
              {["Tøm vanntank og kaffegrut / avfallsbeholder.", "Noter merke, modell og eventuelt serienummer.", "Beskriv feilen så presist som mulig – gjerne når og hvordan den oppstår.", "Ta med eventuelt tilbehør som er relevant for feilen.", "Fyll ut det digitale innleveringsskjemaet på forhånd."].map((i) => (
                <div key={i} className="flex items-start gap-2 bg-white rounded-lg p-4 border border-[#D4A574]/20"><CheckCircle className="h-4 w-4 text-green-600 mt-0.5 shrink-0" /><span className="text-sm text-[#1A1A1A]/80">{i}</span></div>
              ))}
            </div>
          </div>
          <div className="bg-amber-50 rounded-xl p-5 border border-amber-200">
            <div className="flex items-start gap-2"><AlertTriangle className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" /><div>
              <h3 className="font-semibold text-amber-900 mb-1">Maskiner over 9 år</h3>
              <p className="text-sm text-amber-800">For eldre maskiner anbefaler vi å starte med Pakke A (diagnostikk) for å vurdere om reparasjon er lønnsomt før vi går videre.</p>
            </div></div>
          </div>
          <div className="text-center"><Button asChild size="lg" className="bg-[#3D2314] hover:bg-[#3D2314]/90 text-white"><Link to="/innlevering">Gå til innlevering</Link></Button></div>
        </div>
      </section>
    </Layout>
  );
}
